__webpack_require__.p = "/verb-patterns/";